<template>
  <v-flex>
    <div class="mb-6">
      <v-btn to="/weekday/create" color="orange">新增</v-btn>
    </div>

    <v-data-table :headers="thead" :items="datalist" disable-pagination hide-default-footer>
      <template v-slot:item.no="{ item }">
        <span class="blue--text">{{ item.no }}</span>
      </template>

      <!-- <template v-slot:item.available="{ item }">
        <template v-if="item.available">
          <v-icon color="green" class="mr-3">mdi-checkbox-blank-circle</v-icon>啟用
        </template>
        <template v-else>
          <v-icon color="blue-grey lighten-3" class="mr-3">mdi-checkbox-blank-circle-outline</v-icon>停用
        </template>
      </template> -->

      <!-- <template v-slot:item.weekday_type="{ item }">
        <template v-if="item.weekday_type == '1'">
          優惠時段
        </template>
        <template v-else>
          全時段
        </template>
      </template> -->

      <template v-slot:item.id="{ item }">
        <v-btn :to="`/weekday/${item.id}`" outlined color="blue">檢視/修改</v-btn>
      </template>

      <template v-slot:item.delete="{ item }">
        <v-btn @click="deleteRow(item.id)" color="red">刪除</v-btn>
      </template>
    </v-data-table>

    <Confirm @confirm="deleteConfirm" :dialog="dialog" title="是否確認刪除？" text />
  </v-flex>
</template>



<script>
import { mapState, mapActions } from "vuex";

import weekdayApi from "@/api/weekday";
import Confirm from "@/components/Confirm";

export default {
  components: {
    Confirm
  },

  mixins: [],

  props: [],
  data() {
    return {
      datalist: [],

      dialog: false,
      valid: false,
      delete_id: null,

      thead: [
        {
          text: "",
          value: "no",
          align: "center"
        },
        {
          text: "標題",
          value: "title"
        },
        {
          text: "星期",
          value: "weekday",
          align: "center"
        },
        {
          text: "開始時間",
          value: "start_time"
        },
        {
          text: "結束時間",
          value: "end_time"
        },
        {
          text: "編輯",
          value: "id"
        },
        {
          text: "刪除",
          value: "delete"
        }
      ]
    };
  },

  computed: {},
  watch: {},
  methods: {},

  mounted() {
    weekdayApi
      .getAll()
      .then(res => {
        this.datalist = res.data;

        this.datalist.forEach((item, idx) => {
          item.no = idx + 1;
        });
      })
      .catch(err => {});
  },
  methods: {
    deleteRow(val) {
      this.dialog = true
      this.delete_id = val;
    },
    deleteConfirm(result) {
      this.dialog = false;

      if (result) {
        //this.delete(this.delete_id);

        weekdayApi
          .deleteByID(this.delete_id)
          .then(res => {
            window.location.reload();
          })
          .catch(err => {});
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
